export default __webpack_public_path__ + "static/media/map-icon-yellow1.68e900c2.svg";